import { useFilters } from '@statsbomb/kitbag-global-football';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { playerIdAtom } from '@/atoms/player/player';
import { METRIC_KEY, PLAYER_ID } from '@/consts/searchKeys';
import { useSetPlayerEventDataDebouncedFilterParams } from '@/hooks/apiFilterParams/useSetPlayerEventDataDebouncedFilterParams';
import PlayerPreview from '@/pages/player/preview/PlayerPreview';

export const PlayerDataLockerPreview = () => {
  useSetPlayerEventDataDebouncedFilterParams();
  const [searchParams] = useSearchParams();
  const metricKey = searchParams.get(METRIC_KEY);
  const playerId = searchParams.get(PLAYER_ID);

  const [filters, setFilters] = useFilters('main');
  const setPlayerId = useSetAtom(playerIdAtom);

  useEffect(() => {
    if (metricKey && playerId) {
      setFilters({ ...filters, metric: metricKey });
      setPlayerId(Number(playerId));
    }
  }, [metricKey, playerId]);

  if (!playerId || !metricKey) return null;

  return <PlayerPreview />;
};
